<template>
  <div class="sn-f-e-c app-header">
    <template v-if="loginCondition">
      <div class="sn-pointer header-single">
        {{ $sn.encrypted.phone($sn.utils.getLoginPhone()) }}
        <div class="expand" :style="{'--serial': 2}">
          <div class="sn-f-c-c expand-line" @click="navigateUrl('/login/register', '', {
            mode: '3'
          });">个人中心</div>
          <div class="sn-f-c-c expand-line" @click="exit();">退出</div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="sn-pointer header-single" @click="navigateUrl('/login');">登录</div>
    </template>
    <div class="sn-pointer header-single" v-if="language.length > 0">
      {{ current.itemName }}
      <div class="ignore expand" :style="{'--serial': language.length}">
        <div class="sn-f-c-c expand-line language" :class="{'interaction': item.itemCode === current.itemCode}" :key="item.itemCode" v-for="item in language" @click="switchLanguage(item);">
          <div class="iconfont" :class="{
            'icon-circle2yuanquan': item.itemCode !== current.itemCode,
            'icon-xuanze': item.itemCode === current.itemCode
          }"></div>
          <div>{{ item.itemName }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import self from '@/common/utils/global-config';
import * as Constants from '@/common/utils/constants';
import * as Messages from '@/common/utils/messages';
import * as Tools from '@/common/utils/tools';

export default {
  name: 'app-header',
  data() {
    return {
      language: [],
      current: {},
      loginCondition: false,
      exchangeLanguage: self.$sn.getConfig('exchangeLanguage')
    };
  },
  watch: {
    '$route': {
      handler: function() {
        this.loginCondition = this.$sn.utils.getLoginCondition();
      },
      immediate: true
    },
    'exchangeLanguage': {
      handler: async function(config) {
        if (config) {
          const dict = await Tools.dict([Constants.DICTIONARY_CODE_LANGUAGE]);
          if (!this.$sn.validate.empty(dict)) {
            let lang = this.$sn.utils.getUrlVariable('lang');
            if (!lang || this.$sn.validate.empty(dict.find(result => result.itemCode === lang))) {
              lang = dict[0].itemCode;
            }
            this.language = dict;
            this.$sn.TR.service.use('client.edge');
            this.$sn.TR.ignore.class = ['ignore'];
            this.$sn.TR.listener.start();
            this.switchLanguage(this.language.find(result => result.itemCode === lang));
            this.o_m_tr = true;
            window.eventBus.$emit('Broadcast_LanguageComplete');
          }
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.$nextTick(async() => {
      window.eventBus.$on('Broadcast_InitialComplete', () => {
        this.exchangeLanguage = this.$sn.getConfig('exchangeLanguage');
      });
    });
  },
  methods: {
    exit() {
      this.$sn.assembly.modal({
        caption: Messages.C015,
        success: (modal) => {
          if (modal.confirm) {
            this.loginCondition = false;
            Tools.removeLoginInformation();
            this.navigateUrl('/', '', {}, 'replace');
          }
        }
      });
    },
    switchLanguage(item) {
      this.current = item;
      this.$sn.TR.changeLanguage(this.current.itemCode);
      this.$sn.TR.execute();
    },
    navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === '') {
      }
      else if (url.substring(0, 4) === 'http' || url.substring(0, 7) === '/static' || url.substring(0, 2) === '//') {
        window.location.href = url;
      }
      else {
        this.$router[type]({
          path: url,
          query: params || {}
        });
      }
    }
  },
  beforeDestroy() {
    window.eventBus.$off('Broadcast_InitialComplete');
  }
};
</script>
<style lang="scss" scoped>
.app-header {
  @include fs(16);

  width: 100%;
  height: 40px;
  background-color: $main;
  color: $white;
  padding-right: 10%;

  .header-single {
    margin-right: 40px;
    position: relative;

    &:last-child {
      margin-right: 0;
    }

    &:hover {
      .expand {
        opacity: 1;
        height: calc(var(--serial) * 60px);
        border: 1px solid $main;
        box-shadow: 0 0 4px 2px $main9;
      }
    }

    .expand {
      opacity: 0;
      overflow: hidden;
      width: 200px;
      height: 0;
      background-color: $main4;
      color: $black;
      border-radius: 4px;
      padding: 0 10px;
      position: absolute;
      top: 50px;
      left: 50%;
      z-index: 999;
      transform: translateX(-50%);
      transition: linear 200ms;

      &-line {
        height: 60px;
        border-bottom: 1px dashed $main;

        &:last-child {
          border-bottom: none;
        }

        &:hover {
          color: $main;
        }

        &.language {
          position: relative;

          &.interaction {
            font-weight: bold;
            color: $main;

            .iconfont {
              font-weight: normal;
              color: $main;
            }
          }

          .iconfont {
            font-size: 16px;
            color: $text3;
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
          }
        }
      }
    }
  }
}
</style>
